
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";

export default function TermsConditions() {
  return (
    <main className="flex min-h-screen flex-col">
      <SEO 
        title="Terms and Conditions for Secondary Glazing Services"
        description="Our terms and conditions explain the legal agreement between you and London Secondary Glazing for all services and products. Read before purchasing our glazing solutions."
        canonical="https://www.londonsecondaryglazing.co.uk/terms-conditions" 
        keywords="secondary glazing terms, london glazing terms, window installation terms, glazing warranty, service agreement"
      />
      <Navbar />
      <div className="container mx-auto px-4 py-16 flex-grow">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-8 text-primary">Terms & Conditions</h1>
          <div className="prose max-w-none">
            <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">1. Agreement to Terms</h2>
              <p>By accessing and using SecondaryGlazing.London's website and services, you agree to be bound by these Terms and Conditions. If you disagree with any part of these terms, please do not use our services.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">2. Services</h2>
              <p>We provide secondary glazing installation and consultation services. All services are subject to availability and we reserve the right to modify or discontinue any service without notice.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">3. Quotes and Pricing</h2>
              <p>Quotes provided through our website are estimates and may be subject to change following a detailed site survey. Final pricing will be confirmed in writing before any work commences.</p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
}
